import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type {
	LWApiPublicAcronisBackupUsagesParamsRawI,
	LWApiPublicAcronisBackupUsagesResultRawI,
} from '@liquidweb-dev/club-sauce/public/acronis/backup/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const ACRONIS_BACKUP_USAGES_QUERY_KEY = '/acronis/backup/usages';

const useAcronisUsages = (
	params: LWApiPublicAcronisBackupUsagesParamsRawI,
	options?: UseQueryOptions<
		LWApiPublicAcronisBackupUsagesResultRawI,
		ApiErrorI
	>,
) =>
	useQuery({
		queryKey: [ACRONIS_BACKUP_USAGES_QUERY_KEY, params],
		queryFn: () => api.acronis.backup.apiRaw.usages(params),
		...options,
	});

export default useAcronisUsages;
